var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "table-wrapper scrollable general-table",
      class: [_vm.name + "-table"],
    },
    [
      _vm.listPosts
        ? _c(
            "vs-table",
            {
              staticClass: "table-content",
              attrs: {
                notSpacer: "",
                hoverFlat: "",
                pagination: "",
                maxItems: "20",
                data: _vm.listPosts,
                noDataText: _vm.$t("dash.table.no.data"),
                search: "",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ data }) {
                      return [
                        data.length
                          ? _c(
                              "div",
                              { staticClass: "scrollable" },
                              _vm._l(data, function (entry, index) {
                                return _c(
                                  "vs-tr",
                                  {
                                    key: index,
                                    staticClass: "row",
                                    class: [
                                      _vm.formatStatus(entry),
                                      entry.page &&
                                      entry.page[0] &&
                                      entry.page[0].story
                                        ? "story"
                                        : "",
                                    ],
                                    attrs: {
                                      data: entry,
                                      "data-qa": _vm.formatStatus(entry, true),
                                    },
                                  },
                                  [
                                    !entry.page[0] ||
                                    (entry.page[0] && entry.page[0].status != 0)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "container",
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickPost(
                                                  _vm.gridData.pages,
                                                  entry
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "vs-td",
                                              {
                                                staticClass: "column status",
                                                attrs: {
                                                  data: _vm.formatStatus(entry),
                                                },
                                              },
                                              [
                                                entry._bots &&
                                                ((entry._bots.length &&
                                                  entry._bots[0].page &&
                                                  entry._bots[0].page.name) ||
                                                  (entry._bots.page &&
                                                    entry._bots.page.name))
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass: "page-rs",
                                                      },
                                                      [
                                                        _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: entry
                                                                ._bots[0]
                                                                ? entry._bots[0]
                                                                    .page.name
                                                                : entry._bots
                                                                    .page.name,
                                                              position: "top",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "page-image-avatar",
                                                              {
                                                                attrs: {
                                                                  page: entry
                                                                    ._bots[0]
                                                                    ? entry
                                                                        ._bots[0]
                                                                        .page
                                                                    : entry
                                                                        ._bots
                                                                        .page,
                                                                },
                                                              }
                                                            ),
                                                            _vm._v(
                                                              "\n                 \n              "
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "div",
                                                  {
                                                    class:
                                                      _vm.formatStatus(entry),
                                                  },
                                                  [
                                                    _vm.formatStatus(entry) ===
                                                    "draft"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "status-icon",
                                                          attrs: {
                                                            src: require("../../assets/img/icon-draft2.png"),
                                                            alt: "queue",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm.formatStatus(entry) ===
                                                    "draft"
                                                      ? _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.posts.status.draft"
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.formatStatus(entry) ===
                                                    "in queue"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "status-icon",
                                                          attrs: {
                                                            src: require("../../assets/img/ico-inqueue.svg"),
                                                            alt: "queue",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm.formatStatus(entry) ===
                                                    "in queue"
                                                      ? _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.posts.status.inqueue"
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.formatStatus(entry) ===
                                                    "scheduled"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "status-icon",
                                                          attrs: {
                                                            src: require("../../assets/img/ico-scheduled.svg"),
                                                            alt: "scheduled",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm.formatStatus(entry) ===
                                                    "scheduled"
                                                      ? _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.posts.status.scheduled"
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.formatStatus(entry) ===
                                                    "posted"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "status-icon",
                                                          attrs: {
                                                            src: require("../../assets/img/ico-check.svg"),
                                                            alt: "posted",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm.formatStatus(entry) ===
                                                    "posted"
                                                      ? _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.posts.status.posted"
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.formatStatus(entry) ===
                                                    "inprogress"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "status-icon",
                                                          attrs: {
                                                            src: require("../../assets/img/ico-posting.svg"),
                                                            alt: "inprogress",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm.formatStatus(entry) ===
                                                    "inprogress"
                                                      ? _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.posts.status.inprogress"
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _vm.formatStatus(entry) ===
                                                    "failed"
                                                      ? _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.getError(
                                                                entry
                                                              ),
                                                              position: "top",
                                                            },
                                                          },
                                                          [
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "failed"
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("../../assets/img/icon_stop.svg"),
                                                                    alt: "failed",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "failed"
                                                              ? _c("p", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.posts.status.failed"
                                                                      )
                                                                    )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    _vm.formatStatus(entry) ===
                                                    "removed"
                                                      ? _c("img", {
                                                          staticClass:
                                                            "status-icon",
                                                          attrs: {
                                                            src: require("../../assets/img/icon_stop.svg"),
                                                            alt: "removed",
                                                          },
                                                        })
                                                      : _vm._e(),
                                                    _vm.formatStatus(entry) ===
                                                    "removed"
                                                      ? _c("p", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.posts.status.removed"
                                                              )
                                                            )
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "vs-td",
                                              {
                                                staticClass: "column time",
                                                attrs: {
                                                  data: _vm.formatDate(
                                                    entry["published_at"]
                                                  ),
                                                },
                                              },
                                              [
                                                _c("p", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatDate(
                                                        entry["published_at"]
                                                      )
                                                    )
                                                  ),
                                                ]),
                                                _vm.formatStatus(entry) ==
                                                  "draft" &&
                                                entry.scheduled_date
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "posted-date",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n              " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.table.date.scheduled"
                                                              )
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                entry.scheduled_date
                                                              )
                                                            ) +
                                                            "\n            "
                                                        ),
                                                      ]
                                                    )
                                                  : entry.page[0] &&
                                                    entry.page[0][
                                                      "scheduled_date"
                                                    ]
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "posted-date",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n              " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.table.date.scheduled"
                                                              )
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                entry.page[0][
                                                                  "scheduled_date"
                                                                ]
                                                              )
                                                            ) +
                                                            "\n            "
                                                        ),
                                                      ]
                                                    )
                                                  : entry.page[0] &&
                                                    entry.page[0][
                                                      "posted_date"
                                                    ] &&
                                                    [
                                                      "posted",
                                                      "inprogress",
                                                      "failed",
                                                    ].includes(
                                                      _vm.formatStatus(entry)
                                                    )
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "posted-date",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n              " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "dash.table.date.posted"
                                                              )
                                                            ) +
                                                            " " +
                                                            _vm._s(
                                                              _vm.formatDate(
                                                                entry.page[0][
                                                                  "posted_date"
                                                                ]
                                                              )
                                                            ) +
                                                            "\n            "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "vs-td",
                                              {
                                                staticClass: "column content",
                                                attrs: {
                                                  data:
                                                    entry._bots &&
                                                    entry._bots
                                                      .post_text_layout ==
                                                      "description"
                                                      ? entry.description ||
                                                        entry.title
                                                      : entry.title,
                                                },
                                              },
                                              [
                                                ((entry._bots[0] &&
                                                  entry._bots[0].mode ===
                                                    "story" &&
                                                  entry._bots[0].page &&
                                                  entry._bots[0].page
                                                    .story_config &&
                                                  entry._bots[0].page
                                                    .story_config.created) ||
                                                  (entry._bots &&
                                                    entry._bots.mode ===
                                                      "story" &&
                                                    entry._bots.page &&
                                                    entry._bots.page
                                                      .story_config &&
                                                    entry._bots.page
                                                      .story_config.created)) &&
                                                !entry.page[0] &&
                                                entry.enclosure
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "story-img",
                                                      },
                                                      [
                                                        _c("img", {
                                                          attrs: {
                                                            src: entry.enclosure,
                                                            alt: "",
                                                          },
                                                          on: {
                                                            error: _vm.image403,
                                                          },
                                                        }),
                                                        (entry._bots[0] &&
                                                          entry._bots[0]
                                                            .storyTemplate &&
                                                          entry._bots[0]
                                                            .storyTemplate
                                                            .predefined) ||
                                                        (entry._bots &&
                                                          entry._bots
                                                            .storyTemplate &&
                                                          entry._bots
                                                            .storyTemplate
                                                            .predefined)
                                                          ? _c("img", {
                                                              staticClass:
                                                                "template",
                                                              attrs: {
                                                                src: `https://s3.eu-west-1.amazonaws.com/saas.mashup.sandbox/img/${
                                                                  entry._bots[0]
                                                                    ? entry
                                                                        ._bots[0]
                                                                        .storyTemplate
                                                                        .predefined
                                                                    : entry
                                                                        ._bots
                                                                        .storyTemplate
                                                                        .predefined
                                                                }.png`,
                                                                alt: "",
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _c(
                                                          "p",
                                                          {
                                                            class: {
                                                              templatetxt:
                                                                (entry
                                                                  ._bots[0] &&
                                                                  entry._bots[0]
                                                                    .storyTemplate &&
                                                                  entry._bots[0]
                                                                    .storyTemplate
                                                                    .predefined) ||
                                                                (entry._bots &&
                                                                  entry._bots
                                                                    .storyTemplate &&
                                                                  entry._bots
                                                                    .storyTemplate
                                                                    .predefined),
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                entry.title
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "thumb-wrapper",
                                                      },
                                                      [
                                                        ((entry.page &&
                                                          entry.page[0] &&
                                                          entry.page[0]
                                                            .story) ||
                                                          (entry.draft &&
                                                            entry.draft.type ===
                                                              "story")) &&
                                                        entry.page &&
                                                        entry.page[0] &&
                                                        entry.page[0]
                                                          .enclosure &&
                                                        entry.page[0].enclosure.slice(
                                                          -4
                                                        ) === ".mp4"
                                                          ? _c("video", {
                                                              staticClass:
                                                                "thumb story-video-mini",
                                                              attrs: {
                                                                src: entry
                                                                  .page[0]
                                                                  .enclosure,
                                                              },
                                                            })
                                                          : _vm.formatStatus(
                                                              entry
                                                            ) === "draft" &&
                                                            (entry.draft.data
                                                              .form.enclosure ||
                                                              entry.draft.data
                                                                .multipleImages
                                                                .length)
                                                          ? _c("img", {
                                                              staticClass:
                                                                "thumb",
                                                              attrs: {
                                                                src:
                                                                  entry.draft
                                                                    .data
                                                                    .multipleImages &&
                                                                  entry.draft
                                                                    .data
                                                                    .multipleImages
                                                                    .length
                                                                    ? entry
                                                                        .draft
                                                                        .data
                                                                        .multipleImages[0]
                                                                        .url
                                                                    : entry
                                                                        .draft
                                                                        .data
                                                                        .form
                                                                        .enclosure,
                                                              },
                                                              on: {
                                                                error:
                                                                  _vm.replaceByDefault,
                                                              },
                                                            })
                                                          : Array.isArray(
                                                              entry._bots
                                                            ) &&
                                                            entry._bots.length >
                                                              0 &&
                                                            entry._bots[0]
                                                              .mode ===
                                                              "story" &&
                                                            entry.page[0] &&
                                                            entry.page[0].story
                                                          ? _c("img", {
                                                              staticClass:
                                                                "story-screenshot testB",
                                                              attrs: {
                                                                src: JSON.parse(
                                                                  entry.page[0]
                                                                    .story
                                                                ).screenshot,
                                                              },
                                                              on: {
                                                                error:
                                                                  _vm.replaceByDefault,
                                                              },
                                                            })
                                                          : entry._bots &&
                                                            entry._bots.mode ===
                                                              "story" &&
                                                            entry.page[0] &&
                                                            entry.page[0].story
                                                          ? _c("img", {
                                                              staticClass:
                                                                "story-screenshot testA",
                                                              attrs: {
                                                                src: JSON.parse(
                                                                  entry.page[0]
                                                                    .story
                                                                ).screenshot,
                                                              },
                                                              on: {
                                                                error:
                                                                  _vm.replaceByDefault,
                                                              },
                                                            })
                                                          : entry.enclosure
                                                          ? _c("img", {
                                                              staticClass:
                                                                "thumb",
                                                              attrs: {
                                                                src: entry.enclosure,
                                                              },
                                                              on: {
                                                                error:
                                                                  _vm.replaceByDefault,
                                                              },
                                                            })
                                                          : entry.page &&
                                                            entry.page[0] &&
                                                            entry.page[0]
                                                              .enclosure
                                                          ? _c("img", {
                                                              staticClass:
                                                                "thumb",
                                                              attrs: {
                                                                src: entry
                                                                  .page[0]
                                                                  .enclosure,
                                                              },
                                                              on: {
                                                                error:
                                                                  _vm.replaceByDefault,
                                                              },
                                                            })
                                                          : entry.page &&
                                                            entry.page[0] &&
                                                            entry.page[0]
                                                              .carousel &&
                                                            entry.page[0]
                                                              .carousel.length >
                                                              1 &&
                                                            entry.page[0]
                                                              .carousel[0].url
                                                          ? _c("img", {
                                                              staticClass:
                                                                "thumb",
                                                              attrs: {
                                                                src: entry
                                                                  .page[0]
                                                                  .carousel[0]
                                                                  .url,
                                                              },
                                                              on: {
                                                                error:
                                                                  _vm.replaceByDefault,
                                                              },
                                                            })
                                                          : entry.page &&
                                                            entry.page[0] &&
                                                            entry.page[0].video
                                                          ? _c("video", {
                                                              attrs: {
                                                                src: entry
                                                                  .page[0]
                                                                  .video,
                                                              },
                                                            })
                                                          : _vm.formatStatus(
                                                              entry
                                                            ) === "draft" &&
                                                            entry.draft.data
                                                              .videos &&
                                                            _vm.getUrlVideoDraft(
                                                              entry.draft.data
                                                                .videos,
                                                              entry.page[0]
                                                                .network,
                                                              entry.draft.data
                                                                .videoReel
                                                            )
                                                          ? _c("video", {
                                                              attrs: {
                                                                src: _vm.getUrlVideoDraft(
                                                                  entry.draft
                                                                    .data
                                                                    .videos,
                                                                  entry.page[0]
                                                                    .network,
                                                                  entry.draft
                                                                    .data
                                                                    .videoReel
                                                                ),
                                                              },
                                                            })
                                                          : entry.url &&
                                                            entry.url != ""
                                                          ? _c("img", {
                                                              ref: `meta-image-${entry.id}`,
                                                              refInFor: true,
                                                              staticClass:
                                                                "thumb",
                                                              attrs: {
                                                                meta: _vm.getMetaOgImage(
                                                                  entry,
                                                                  `meta-image-${entry.id}`,
                                                                  index
                                                                ),
                                                              },
                                                              on: {
                                                                error:
                                                                  _vm.replaceByDefault,
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "txt-wrapper",
                                                  },
                                                  [
                                                    _c("p", [
                                                      entry._bots &&
                                                      entry._bots[0] &&
                                                      entry._bots[0].mode ===
                                                        "story" &&
                                                      entry.page &&
                                                      entry.page[0] &&
                                                      entry.page[0].enclosure &&
                                                      entry.page[0].enclosure.slice(
                                                        -4
                                                      ) === ".mp4"
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "Story video"
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      entry.page &&
                                                      entry.page[0] &&
                                                      entry.page[0].is_reshare
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "[" +
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "dash.post.reshare"
                                                                  )
                                                                ) +
                                                                "] " +
                                                                _vm._s(
                                                                  entry.page[0]
                                                                    .reshare_message
                                                                ) +
                                                                " - "
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      entry.page &&
                                                      entry.page[0] &&
                                                      entry.page[0].is_retweet
                                                        ? _c("span", [
                                                            _vm._v(
                                                              "[Retweet] "
                                                            ),
                                                          ])
                                                        : _vm._e(),
                                                      _c("span", {
                                                        staticClass: "hin",
                                                        domProps: {
                                                          innerHTML: _vm._s(
                                                            _vm.getText(entry)
                                                          ),
                                                        },
                                                      }),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            entry.flux &&
                                            entry.flux.source &&
                                            entry.flux.source.name
                                              ? _c(
                                                  "vs-td",
                                                  {
                                                    staticClass:
                                                      "column source",
                                                    attrs: {
                                                      data: entry.flux.source
                                                        .name,
                                                    },
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          entry.flux.source.name
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _vm.sources &&
                                                _vm.sources.find(
                                                  (s) =>
                                                    entry.flux &&
                                                    s.uid == entry.flux.id
                                                )
                                              ? _c(
                                                  "vs-td",
                                                  {
                                                    staticClass:
                                                      "column source",
                                                    attrs: {
                                                      data: _vm.sources.find(
                                                        (s) =>
                                                          entry.flux &&
                                                          s.uid == entry.flux.id
                                                      ).name,
                                                    },
                                                  },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.sources.find(
                                                            (s) =>
                                                              entry.flux &&
                                                              s.uid ==
                                                                entry.flux.id
                                                          ).name
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                )
                                              : _c("vs-td", {
                                                  staticClass: "column source",
                                                  attrs: { data: "Custom" },
                                                }),
                                            ["posted", "failed"].includes(
                                              _vm.formatStatus(entry)
                                            ) &&
                                            entry.page[0] &&
                                            entry.page[0].network == "facebook"
                                              ? _c(
                                                  "vs-td",
                                                  {
                                                    staticClass: "column both",
                                                    attrs: {
                                                      data: entry.page[0]
                                                        .insights
                                                        ? entry.page[0].insights.find(
                                                            (i) =>
                                                              i.name ==
                                                              "post_impressions"
                                                          ).values[0].value
                                                        : "",
                                                    },
                                                  },
                                                  [
                                                    entry.page[0].insights
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "sources",
                                                          },
                                                          [
                                                            _c("li", [
                                                              _c("img", {
                                                                staticClass:
                                                                  "icon-white",
                                                                attrs: {
                                                                  src: require("../../assets/img/rss/icon_vues.svg"),
                                                                  alt: "vues",
                                                                },
                                                              }),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    entry.page[0].insights.find(
                                                                      (i) =>
                                                                        i.name ==
                                                                        "post_impressions"
                                                                    ).values[0]
                                                                      .value
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                            _c("li", [
                                                              _c("img", {
                                                                staticClass:
                                                                  "icon-white",
                                                                attrs: {
                                                                  src: require("../../assets/img/rss/icon_likes.svg"),
                                                                  alt: "likes",
                                                                },
                                                              }),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    entry.page[0].insights.find(
                                                                      (i) =>
                                                                        i.name ==
                                                                        "post_reactions_like_total"
                                                                    ).values[0]
                                                                      .value
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                            _c("li", [
                                                              _c("img", {
                                                                staticClass:
                                                                  "icon-white",
                                                                attrs: {
                                                                  src: require("../../assets/img/rss/icon_clicks.svg"),
                                                                  alt: "clicks",
                                                                },
                                                              }),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    entry.page[0].insights.find(
                                                                      (i) =>
                                                                        i.name ==
                                                                        "post_clicks"
                                                                    ).values[0]
                                                                      .value
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    entry.page[0] &&
                                                    entry.page[0].network ==
                                                      "facebook"
                                                      ? _c(
                                                          "vs-button",
                                                          {
                                                            staticClass:
                                                              "btn-large",
                                                            attrs: {
                                                              color: "#6a1f4c",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.clickPost(
                                                                  _vm.gridData
                                                                    .pages,
                                                                  entry
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.posts.view"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : ["posted", "failed"].includes(
                                                  _vm.formatStatus(entry)
                                                ) &&
                                                entry.page[0] &&
                                                entry.page[0].network ==
                                                  "twitter"
                                              ? _c(
                                                  "vs-td",
                                                  {
                                                    staticClass: "column both",
                                                    attrs: {
                                                      data: entry.page[0]
                                                        .insights
                                                        ? entry.page[0].insights
                                                            .retweet_count
                                                        : "",
                                                    },
                                                  },
                                                  [
                                                    entry.page[0].insights
                                                      ? _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "sources",
                                                          },
                                                          [
                                                            _c("li", [
                                                              _c("img", {
                                                                staticClass:
                                                                  "icon-white",
                                                                attrs: {
                                                                  src: require("../../assets/img/rss/icon_retweet.svg"),
                                                                  alt: "vues",
                                                                },
                                                              }),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    entry
                                                                      .page[0]
                                                                      .insights
                                                                      .retweet_count
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                            _c("li", [
                                                              _c("img", {
                                                                staticClass:
                                                                  "icon-white",
                                                                attrs: {
                                                                  src: require("../../assets/img/rss/icon_likes.svg"),
                                                                  alt: "likes",
                                                                },
                                                              }),
                                                              _c("p", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    entry
                                                                      .page[0]
                                                                      .insights
                                                                      .favorite_count
                                                                  )
                                                                ),
                                                              ]),
                                                            ]),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                    entry.page[0] &&
                                                    entry.page[0].network ==
                                                      "twitter"
                                                      ? _c(
                                                          "vs-button",
                                                          {
                                                            staticClass:
                                                              "btn-large",
                                                            attrs: {
                                                              color: "#6a1f4c",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.clickPost(
                                                                  _vm.gridData
                                                                    .pages,
                                                                  entry
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "dash.posts.view"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : [
                                                  "posted",
                                                  "failed",
                                                  "removed",
                                                ].includes(
                                                  _vm.formatStatus(entry)
                                                )
                                              ? _c(
                                                  "vs-td",
                                                  {
                                                    staticClass: "column both",
                                                  },
                                                  [
                                                    _c(
                                                      "vs-button",
                                                      {
                                                        staticClass:
                                                          "btn-large",
                                                        attrs: {
                                                          color: "#6a1f4c",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickPost(
                                                              _vm.gridData
                                                                .pages,
                                                              entry
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "dash.posts.view"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                )
                                              : _vm.formatStatus(entry) !==
                                                "posted"
                                              ? _c(
                                                  "vs-td",
                                                  {
                                                    staticClass:
                                                      "column both cell",
                                                    attrs: {
                                                      data:
                                                        entry._bots &&
                                                        entry._bots
                                                          .post_text_layout ==
                                                          "description"
                                                          ? entry.description
                                                          : entry.title,
                                                    },
                                                  },
                                                  [
                                                    _vm.formatStatus(entry) ===
                                                    "in queue"
                                                      ? _c(
                                                          "vs-button",
                                                          {
                                                            staticClass:
                                                              "btn-large",
                                                            attrs: {
                                                              disabled:
                                                                !_vm.canUseCustomSources &&
                                                                (!entry.categorie ||
                                                                  !entry
                                                                    .categorie
                                                                    .id),
                                                              color: "#6a1f4c",
                                                              "vs-type":
                                                                "filled",
                                                              size: "large",
                                                              type: "submit",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.clickPost(
                                                                  _vm.gridData
                                                                    .pages,
                                                                  entry
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  ![
                                                                    "Admin",
                                                                    "Editor",
                                                                    "Writter",
                                                                  ].includes(
                                                                    _vm.getUserRole
                                                                  )
                                                                    ? "dash.posts.view"
                                                                    : "dash.button.post"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.formatStatus(
                                                          entry
                                                        ) === "scheduled"
                                                      ? _c(
                                                          "vs-button",
                                                          {
                                                            staticClass:
                                                              "btn-large",
                                                            attrs: {
                                                              disabled:
                                                                !_vm.canUseCustomSources &&
                                                                (!entry.categorie ||
                                                                  !entry
                                                                    .categorie
                                                                    .id),
                                                              color: "#6a1f4c",
                                                              "vs-type":
                                                                "border",
                                                              size: "large",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.clickPost(
                                                                  _vm.gridData
                                                                    .pages,
                                                                  entry
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  ![
                                                                    "Admin",
                                                                    "Editor",
                                                                    "Writter",
                                                                  ].includes(
                                                                    _vm.getUserRole
                                                                  )
                                                                    ? "dash.posts.view"
                                                                    : "dash.button.edit"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm.formatStatus(
                                                          entry
                                                        ) === "draft"
                                                      ? _c(
                                                          "vs-button",
                                                          {
                                                            staticClass:
                                                              "btn-large",
                                                            attrs: {
                                                              disabled:
                                                                !_vm.canUseCustomSources &&
                                                                (!entry.categorie ||
                                                                  !entry
                                                                    .categorie
                                                                    .id),
                                                              color: "#6a1f4c",
                                                              "vs-type":
                                                                "border",
                                                              size: "large",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  ![
                                                                    "Admin",
                                                                    "Editor",
                                                                    "Writter",
                                                                  ].includes(
                                                                    _vm.getUserRole
                                                                  )
                                                                    ? "dash.posts.view"
                                                                    : "dash.button.edit"
                                                                )
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                )
                                              : _c("vs-td", {
                                                  staticClass: "column both",
                                                }),
                                            _c(
                                              "vs-td",
                                              { staticClass: "column both" },
                                              [
                                                _vm.formatStatus(entry) ===
                                                "in queue"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "remove-post",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.excludeNewsFromList(
                                                              entry
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.$t(
                                                                "dash.button.exclude.news"
                                                              ),
                                                              position: "top",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "vs-icon notranslate icon-scale material-icons",
                                                                staticStyle: {
                                                                  background:
                                                                    "rgb(255, 255, 255)",
                                                                },
                                                              },
                                                              [_vm._v("close")]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : [
                                                      "scheduled",
                                                      "draft",
                                                      "posted",
                                                      "failed",
                                                    ].includes(
                                                      _vm.formatStatus(entry)
                                                    )
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "remove-post",
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.deletePost(
                                                              entry
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "Tooltip",
                                                          {
                                                            attrs: {
                                                              text: _vm.$t(
                                                                "dash.button.delete.post"
                                                              ),
                                                              position: "top",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "i",
                                                              {
                                                                staticClass:
                                                                  "vs-icon notranslate icon-scale material-icons",
                                                                staticStyle: {
                                                                  background:
                                                                    "rgb(255, 255, 255)",
                                                                },
                                                              },
                                                              [_vm._v("close")]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                            _c(
                                              "template",
                                              { slot: "expand" },
                                              [
                                                _c(
                                                  "vs-list",
                                                  [
                                                    _c(
                                                      "vs-list-item",
                                                      {
                                                        staticClass: "status",
                                                        attrs: {
                                                          title:
                                                            _vm.$t(
                                                              "dash.table.title.status"
                                                            ) + " :",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            class:
                                                              _vm.formatStatus(
                                                                entry
                                                              ),
                                                          },
                                                          [
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "in queue"
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("../../assets/img/icon_wait_grey.svg"),
                                                                    alt: "queue",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "in queue"
                                                              ? _c("p", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.posts.status.inqueue"
                                                                      )
                                                                    )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "scheduled"
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("../../assets/img/icon_time_black.svg"),
                                                                    alt: "scheduled",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "scheduled"
                                                              ? _c("p", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.posts.status.scheduled"
                                                                      )
                                                                    )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "posted"
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("../../assets/img/icon_check_purple.svg"),
                                                                    alt: "posted",
                                                                  },
                                                                })
                                                              : _c("p", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.posts.status.posted"
                                                                      )
                                                                    )
                                                                  ),
                                                                ]),
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "inprogress"
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("../../assets/img/icon_wait_grey.svg"),
                                                                    alt: "posted",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "inprogress"
                                                              ? _c("p", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.posts.status.inprogress"
                                                                      )
                                                                    )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "failed"
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("../../assets/img/icon_stop.svg"),
                                                                    alt: "failed",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "failed"
                                                              ? _c("p", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.posts.status.failed"
                                                                      )
                                                                    )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "removed"
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "status-icon",
                                                                  attrs: {
                                                                    src: require("../../assets/img/icon_stop.svg"),
                                                                    alt: "removed",
                                                                  },
                                                                })
                                                              : _vm._e(),
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "removed"
                                                              ? _c("p", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "dash.posts.status.removed"
                                                                      )
                                                                    )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-list-item",
                                                      {
                                                        staticClass: "date",
                                                        attrs: {
                                                          title:
                                                            _vm.$t(
                                                              "dash.table.title.time"
                                                            ) + " :",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatDate(
                                                              entry[
                                                                "published_at"
                                                              ]
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-list-item",
                                                      {
                                                        staticClass: "content",
                                                        attrs: {
                                                          title:
                                                            _vm.$t(
                                                              "dash.table.title.content"
                                                            ) + " :",
                                                        },
                                                      },
                                                      [
                                                        ((entry._bots[0] &&
                                                          entry._bots[0]
                                                            .mode === "story" &&
                                                          entry._bots[0].page &&
                                                          entry._bots[0].page
                                                            .story_config &&
                                                          entry._bots[0].page
                                                            .story_config
                                                            .created) ||
                                                          (entry._bots &&
                                                            entry._bots.mode ===
                                                              "story" &&
                                                            entry._bots.page &&
                                                            entry._bots.page
                                                              .story_config &&
                                                            entry._bots.page
                                                              .story_config
                                                              .created)) &&
                                                        !entry.page[0] &&
                                                        entry.enclosure
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "story-img",
                                                              },
                                                              [
                                                                _c("img", {
                                                                  attrs: {
                                                                    src: entry.enclosure,
                                                                    alt: "",
                                                                  },
                                                                  on: {
                                                                    error:
                                                                      _vm.image403,
                                                                  },
                                                                }),
                                                                _c("p", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      entry.title
                                                                    )
                                                                  ),
                                                                ]),
                                                              ]
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "thumb-wrapper",
                                                              },
                                                              [
                                                                Array.isArray(
                                                                  entry._bots
                                                                ) &&
                                                                entry._bots
                                                                  .length > 0 &&
                                                                entry._bots[0]
                                                                  .mode ===
                                                                  "story" &&
                                                                entry.screenshot
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "thumb",
                                                                      attrs: {
                                                                        src: entry.screenshot,
                                                                      },
                                                                      on: {
                                                                        error:
                                                                          _vm.replaceByDefault,
                                                                      },
                                                                    })
                                                                  : entry._bots &&
                                                                    entry._bots
                                                                      .mode ===
                                                                      "story" &&
                                                                    entry.screenshot
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "thumb",
                                                                      attrs: {
                                                                        src: entry.screenshot,
                                                                      },
                                                                      on: {
                                                                        error:
                                                                          _vm.replaceByDefault,
                                                                      },
                                                                    })
                                                                  : entry.enclosure
                                                                  ? _c("img", {
                                                                      staticClass:
                                                                        "thumb",
                                                                      attrs: {
                                                                        src: entry.enclosure,
                                                                      },
                                                                      on: {
                                                                        error:
                                                                          _vm.replaceByDefault,
                                                                      },
                                                                    })
                                                                  : _c("img", {
                                                                      ref: `meta-image-${entry.id}`,
                                                                      refInFor: true,
                                                                      staticClass:
                                                                        "thumb",
                                                                      attrs: {
                                                                        meta: _vm.getMetaOgImage(
                                                                          entry,
                                                                          `meta-image-${entry.id}`,
                                                                          index
                                                                        ),
                                                                      },
                                                                      on: {
                                                                        error:
                                                                          _vm.replaceByDefault,
                                                                      },
                                                                    }),
                                                              ]
                                                            ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "txt-wrapper",
                                                          },
                                                          [
                                                            _c("p", {
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.getText(
                                                                      entry
                                                                    )
                                                                  ),
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "vs-list-item",
                                                      {
                                                        staticClass: "url",
                                                        attrs: {
                                                          title: "URL :",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(entry.url)
                                                        ),
                                                      ]
                                                    ),
                                                    entry.flux &&
                                                    entry.flux.source &&
                                                    entry.flux.source.name
                                                      ? _c(
                                                          "vs-list-item",
                                                          {
                                                            staticClass:
                                                              "sources",
                                                            attrs: {
                                                              data: entry.flux
                                                                .source.name,
                                                              title:
                                                                _vm.$t(
                                                                  "dash.table.title.source"
                                                                ) + " :",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                entry.flux
                                                                  .source.name
                                                              )
                                                            ),
                                                          ]
                                                        )
                                                      : _c("vs-list-item", {
                                                          staticClass:
                                                            "sources",
                                                          attrs: {
                                                            title:
                                                              _vm.$t(
                                                                "dash.table.title.source"
                                                              ) + " :",
                                                            subtitle: "Custom",
                                                          },
                                                        }),
                                                    _vm.formatStatus(entry) ===
                                                      "posted" &&
                                                    entry.page[0] &&
                                                    entry.page[0].network ==
                                                      "facebook"
                                                      ? _c(
                                                          "vs-list-item",
                                                          {
                                                            staticClass:
                                                              "stats",
                                                            attrs: {
                                                              title:
                                                                _vm.$t(
                                                                  "dash.table.title.stats"
                                                                ) + " :",
                                                            },
                                                          },
                                                          [
                                                            entry.page[0]
                                                              .insights
                                                              ? _c(
                                                                  "ul",
                                                                  {
                                                                    staticClass:
                                                                      "sources",
                                                                  },
                                                                  [
                                                                    _c("li", [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "icon-white",
                                                                          attrs:
                                                                            {
                                                                              src: require("../../assets/img/rss/icon_vues.svg"),
                                                                              alt: "vues",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c("p", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            entry.page[0].insights.find(
                                                                              (
                                                                                i
                                                                              ) =>
                                                                                i.name ==
                                                                                "post_impressions"
                                                                            )
                                                                              .values[0]
                                                                              .value
                                                                          )
                                                                        ),
                                                                      ]),
                                                                    ]),
                                                                    _c("li", [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "icon-white",
                                                                          attrs:
                                                                            {
                                                                              src: require("../../assets/img/rss/icon_likes.svg"),
                                                                              alt: "likes",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c("p", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            entry.page[0].insights.find(
                                                                              (
                                                                                i
                                                                              ) =>
                                                                                i.name ==
                                                                                "post_reactions_like_total"
                                                                            )
                                                                              .values[0]
                                                                              .value
                                                                          )
                                                                        ),
                                                                      ]),
                                                                    ]),
                                                                    _c("li", [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "icon-white",
                                                                          attrs:
                                                                            {
                                                                              src: require("../../assets/img/rss/icon_clicks.svg"),
                                                                              alt: "clicks",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c("p", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            entry.page[0].insights.find(
                                                                              (
                                                                                i
                                                                              ) =>
                                                                                i.name ==
                                                                                "post_clicks"
                                                                            )
                                                                              .values[0]
                                                                              .value
                                                                          )
                                                                        ),
                                                                      ]),
                                                                    ]),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            entry.page[0] &&
                                                            entry.page[0]
                                                              .network ==
                                                              "facebook"
                                                              ? _c(
                                                                  "vs-button",
                                                                  {
                                                                    staticClass:
                                                                      "btn-large",
                                                                    attrs: {
                                                                      color:
                                                                        "#6a1f4c",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.clickPost(
                                                                            _vm
                                                                              .gridData
                                                                              .pages,
                                                                            entry
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "dash.posts.view"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm.formatStatus(
                                                          entry
                                                        ) === "posted" &&
                                                        entry.page[0] &&
                                                        entry.page[0].network ==
                                                          "twitter"
                                                      ? _c(
                                                          "vs-list-item",
                                                          {
                                                            staticClass:
                                                              "stats",
                                                            attrs: {
                                                              title:
                                                                _vm.$t(
                                                                  "dash.table.title.stats"
                                                                ) + " :",
                                                            },
                                                          },
                                                          [
                                                            entry.page[0]
                                                              .insights
                                                              ? _c(
                                                                  "ul",
                                                                  {
                                                                    staticClass:
                                                                      "sources",
                                                                  },
                                                                  [
                                                                    _c("li", [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "icon-white",
                                                                          attrs:
                                                                            {
                                                                              src: require("../../assets/img/rss/icon_retweet.svg"),
                                                                              alt: "vues",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c("p", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            entry
                                                                              .page[0]
                                                                              .insights
                                                                              .retweet_count
                                                                          )
                                                                        ),
                                                                      ]),
                                                                    ]),
                                                                    _c("li", [
                                                                      _c(
                                                                        "img",
                                                                        {
                                                                          staticClass:
                                                                            "icon-white",
                                                                          attrs:
                                                                            {
                                                                              src: require("../../assets/img/rss/icon_likes.svg"),
                                                                              alt: "likes",
                                                                            },
                                                                        }
                                                                      ),
                                                                      _c("p", [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            entry
                                                                              .page[0]
                                                                              .insights
                                                                              .favorite_count
                                                                          )
                                                                        ),
                                                                      ]),
                                                                    ]),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                            entry.page[0] &&
                                                            entry.page[0]
                                                              .network ==
                                                              "twitter"
                                                              ? _c(
                                                                  "vs-button",
                                                                  {
                                                                    staticClass:
                                                                      "btn-large",
                                                                    attrs: {
                                                                      color:
                                                                        "#6a1f4c",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.clickPost(
                                                                            _vm
                                                                              .gridData
                                                                              .pages,
                                                                            entry
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "dash.posts.view"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm.formatStatus(
                                                          entry
                                                        ) !== "posted"
                                                      ? _c(
                                                          "vs-list-item",
                                                          {
                                                            staticClass:
                                                              "actions",
                                                            attrs: {
                                                              title:
                                                                _vm.$t(
                                                                  "dash.table.title.actions"
                                                                ) + " :",
                                                            },
                                                          },
                                                          [
                                                            _vm.formatStatus(
                                                              entry
                                                            ) === "in queue"
                                                              ? _c(
                                                                  "vs-button",
                                                                  {
                                                                    staticClass:
                                                                      "btn-large",
                                                                    attrs: {
                                                                      disabled:
                                                                        !_vm.canUseCustomSources &&
                                                                        (!entry.categorie ||
                                                                          !entry
                                                                            .categorie
                                                                            .id),
                                                                      color:
                                                                        "#6a1f4c",
                                                                      "vs-type":
                                                                        "filled",
                                                                      size: "large",
                                                                      type: "submit",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          return _vm.clickPost(
                                                                            _vm
                                                                              .gridData
                                                                              .pages,
                                                                            entry
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          ![
                                                                            "Admin",
                                                                            "Editor",
                                                                            "Writter",
                                                                          ].includes(
                                                                            _vm.getUserRole
                                                                          )
                                                                            ? "dash.posts.view"
                                                                            : "dash.button.post"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm.formatStatus(
                                                                  entry
                                                                ) ===
                                                                "scheduled"
                                                              ? _c(
                                                                  "vs-button",
                                                                  {
                                                                    staticClass:
                                                                      "btn-large",
                                                                    attrs: {
                                                                      disabled:
                                                                        !_vm.canUseCustomSources &&
                                                                        (!entry.categorie ||
                                                                          !entry
                                                                            .categorie
                                                                            .id),
                                                                      color:
                                                                        "#6a1f4c",
                                                                      "vs-type":
                                                                        "border",
                                                                      size: "large",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.preventDefault()
                                                                          return _vm.clickPost(
                                                                            _vm
                                                                              .gridData
                                                                              .pages,
                                                                            entry
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          ![
                                                                            "Admin",
                                                                            "Editor",
                                                                            "Writter",
                                                                          ].includes(
                                                                            _vm.getUserRole
                                                                          )
                                                                            ? "dash.posts.view"
                                                                            : "dash.button.edit"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ],
                                                          1
                                                        )
                                                      : _vm.formatStatus(
                                                          entry
                                                        ) == "posted"
                                                      ? _c(
                                                          "vs-list-item",
                                                          {
                                                            staticClass:
                                                              "actions",
                                                            attrs: {
                                                              title:
                                                                _vm.$t(
                                                                  "dash.table.title.actions"
                                                                ) + " :",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "vs-button",
                                                              {
                                                                staticClass:
                                                                  "btn-large",
                                                                attrs: {
                                                                  color:
                                                                    "#6a1f4c",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.clickPost(
                                                                        _vm
                                                                          .gridData
                                                                          .pages,
                                                                        entry
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "dash.posts.view"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          2
                                        )
                                      : _vm._e(),
                                  ]
                                )
                              }),
                              1
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ],
                null,
                false,
                4071253372
              ),
            },
            [
              _c(
                "template",
                { slot: "thead" },
                [
                  _c(
                    "vs-th",
                    {
                      staticClass: "column status",
                      attrs: { "sort-key": "status" },
                    },
                    [
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("dash.table.title.status"))),
                      ]),
                      _c("span", { staticClass: "sort-th" }, [
                        _c(
                          "i",
                          {
                            staticClass:
                              "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                          },
                          [_vm._v("\n            expand_less\n          ")]
                        ),
                        _c(
                          "i",
                          {
                            staticClass:
                              "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                          },
                          [_vm._v("\n            expand_more\n          ")]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "vs-th",
                    {
                      staticClass: "column time sort",
                      attrs: { "sort-key": "published_at" },
                    },
                    [
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("dash.table.title.time"))),
                      ]),
                      _c("span", { staticClass: "sort-th" }, [
                        _c(
                          "i",
                          {
                            staticClass:
                              "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                          },
                          [_vm._v("\n            expand_less\n          ")]
                        ),
                        _c(
                          "i",
                          {
                            staticClass:
                              "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                          },
                          [_vm._v("\n            expand_more\n          ")]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "vs-th",
                    {
                      staticClass: "column content sort",
                      attrs: { "sort-key": "title" },
                    },
                    [
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("dash.table.title.content"))),
                      ]),
                      _c("span", { staticClass: "sort-th" }, [
                        _c(
                          "i",
                          {
                            staticClass:
                              "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                          },
                          [_vm._v("\n            expand_less\n          ")]
                        ),
                        _c(
                          "i",
                          {
                            staticClass:
                              "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                          },
                          [_vm._v("\n            expand_more\n          ")]
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "vs-th",
                    {
                      staticClass: "column source",
                      attrs: { "sort-key": "flux_name" },
                    },
                    [
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("dash.table.title.source"))),
                      ]),
                      _c("span", { staticClass: "sort-th" }, [
                        _c(
                          "i",
                          {
                            staticClass:
                              "vs-icon notranslate icon-scale th-sort-icon material-icons up-sort",
                          },
                          [_vm._v("\n            expand_less\n          ")]
                        ),
                        _c(
                          "i",
                          {
                            staticClass:
                              "vs-icon notranslate icon-scale th-sort-icon material-icons down-sort",
                          },
                          [_vm._v("\n            expand_more\n          ")]
                        ),
                      ]),
                    ]
                  ),
                  _vm.filter.includes("all")
                    ? _c("vs-th", { staticClass: "column both" }, [
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("dash.table.title.both"))),
                        ]),
                      ])
                    : _vm.filter.includes("scheduled") ||
                      _vm.filter.includes("queue") ||
                      _vm.filter.includes("failed") ||
                      _vm.filter.includes("removed")
                    ? _c("vs-th", { staticClass: "column both" }, [
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("dash.table.title.actions"))),
                        ]),
                      ])
                    : _vm.filter.includes("posted")
                    ? _c("vs-th", { staticClass: "column both" }, [
                        _c("p", [
                          _vm._v(_vm._s(_vm.$t("dash.table.title.stats"))),
                        ]),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
      _c(
        "vs-popup",
        {
          class: `sidebar-action ${_vm.version}`,
          attrs: { title: ``, active: _vm.showSidebar },
          on: {
            "update:active": function ($event) {
              _vm.showSidebar = $event
            },
          },
        },
        [
          _vm.gridData.pages && _vm.post && _vm.post._bots
            ? _c("component-post-sidebar", {
                attrs: {
                  gridData: _vm.gridData,
                  postOriginal: _vm.post,
                  sectionPlanner: false,
                },
                on: {
                  edit: _vm.editPost,
                  deleteScheduled: _vm.deleteScheduledEvent,
                  excludeNews: _vm.excludeNewsEvent,
                  validate: _vm.validatePostEvent,
                  resharePost: _vm.resharePost,
                  retweetPost: _vm.retweetPost,
                  openLoader: _vm.openLoader,
                  validateScheduledPost: _vm.validateScheduledPostEvent,
                  removeValidateScheduledPost:
                    _vm.removeValidateScheduledPostEvent,
                  addComment: _vm.addComment,
                  shareStory: _vm.shareToStory,
                  editDraft: _vm.editDraft,
                  removeDrafts: _vm.removeDrafts,
                  duplicatePost: _vm.duplicatePost,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "vs-prompt",
        {
          staticClass: "prompt-remove-posts",
          attrs: {
            color: "#6a1f4c",
            "cancel-text": _vm.$t(
              "dash.posts.multi-pages.remove.prompt.btn-only-one"
            ),
            "accept-text": _vm.$t(
              "dash.posts.multi-pages.remove.prompt.btn-all"
            ),
            title: _vm.$t("dash.posts.multi-pages.remove.prompt.title"),
            active: _vm.removePostsMultiPages,
          },
          on: {
            close: function ($event) {
              _vm.removePostsMultiPages = false
            },
            cancel: function ($event) {
              _vm.post.status == "draft"
                ? _vm.removeDraft(_vm.post._bots[0].page)
                : _vm.removePost()
            },
            accept: function ($event) {
              _vm.post.status == "draft"
                ? _vm.removeDraft()
                : _vm.deletePostsMultiPages()
            },
            "update:active": function ($event) {
              _vm.removePostsMultiPages = $event
            },
          },
        },
        [
          _c("div", { staticClass: "con-exemple-prompt" }, [
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("dash.posts.multi-pages.remove.prompt.content")) +
                "          \n      "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }